// This function is intended to be called by experimentation engine to expose
// the shade filter tabs to the user
window.showShadeFilterTabs = () => {
  const tabsPresent = document.getElementById('shades-tabs-horizontal-scroll');

  const liveComponentSelector = document.getElementById('product-details-live-component')
    ? '#product-details-live-component'
    : '#shades-picker-live-component';

  if (tabsPresent || liveComponentSelector == '#shades-picker-live-component') {
    window.dispatchEvent(
      new CustomEvent('vulcan:hook-relay:push-event-to', {
        detail: {
          selectorOrTarget: liveComponentSelector,
          event: 'show_shade_tabs'
        }
      })
    );

    return true;
  } else {
    return false;
  }
};

// With exception of above function (which has to remain a top-level function until the experiment is over),
// this top-level window object is where experimentation state and functions are located.
window.experimentation = {
  showStickyATBCalled: false,
  stickyATBEventSent: false,
  showStickyATB: () => {
    window.experimentation.showStickyATBCalled = true;
  }
};
